import { useTranslation } from 'react-i18next';

import type { NumberingSeries } from '~/types/user';

import { Button, Dialog, Icon } from '~/components';
import { statusColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';

import type { CreditNoteConfirmationData } from './dialogs.types';

import { peppolNoticeStyle } from './CreditNoteConfirmationDialog.css';
import { EditEntryNumberForm } from './EditEntryNumberForm';
import { useEntryNumberForm } from './EditEntryNumberForm.hooks';

type Props = {
  disabled: boolean;
  numberingSeries: NumberingSeries;
  onConfirm: (data: CreditNoteConfirmationData) => void;
  peppol: boolean;
};

export const CreditNoteConfirmationDialog = (props: Props) => {
  return (
    <Dialog.Body>
      <CreditNoteConfirmationDialogContent {...props} />
    </Dialog.Body>
  );
};

const CreditNoteConfirmationDialogContent = ({ disabled, numberingSeries, onConfirm, peppol }: Props) => {
  const { fcEntryNumber, form } = useEntryNumberForm(numberingSeries);
  const { t } = useTranslation(['common', 'creditnotes']);

  return (
    <>
      <Dialog.Header title={t('creditnotes:create.confirmation.title')} />

      <p>{t('creditnotes:create.confirmation.description')}</p>

      {peppol && (
        <p className={clsx(peppolNoticeStyle, statusColorThemes.info)}>
          <Icon name="Peppol" size={16} />
          {t('creditnotes:create.confirmation.sentWithPeppol')}
        </p>
      )}

      <EditEntryNumberForm fcEntryNumber={fcEntryNumber} form={form} numberingSeries={numberingSeries} type="creditNote" />

      <Dialog.Actions>
        <Button disabled={disabled} icon="Send" onClick={() => onConfirm({ fcEntryNumber, nextNumber: form.getValues('nextNumber') + 1 })}>
          {t('creditnotes:create.confirmation.submit')}
        </Button>
      </Dialog.Actions>
    </>
  );
};
